import {Box, Button, Flex, Heading, Text} from "@chakra-ui/react";
import React from "react";
import HomeHero from "../elements/HomeHero";
import Page from "../layout/Page";
import Seperator from "../layout/Seperator";
import HomeExplain from "../Explainer/HomeExplain";
import {FAQSection} from "../Explainer/FAQSection";
import {Link} from "react-router-dom";

export default function Home() {
	return (
		<Page
			fullsize
			title={"DearUniverse Shop - Nachricht ins All schicken"}
			description={
				"DearUniverse Shop: Sende Nachrichten ins Weltall und bestelle hochwertige Weltraum-Poster! 💫"
			}
			footer>
			<HomeHero />
			<Flex
				justifyContent={"center"}
				bgColor={"white"}
				backgroundImage={`url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1079%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(238%2c 238%2c 238%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c474.975C87.512%2c466.898%2c130.027%2c364.573%2c200.894%2c312.597C265.973%2c264.865%2c364.92%2c255.375%2c399.098%2c182.262C433.288%2c109.124%2c373.555%2c27.231%2c372.029%2c-53.49C370.2%2c-150.212%2c438.398%2c-253.969%2c389.273%2c-337.307C340.592%2c-419.892%2c229.32%2c-445.197%2c134.183%2c-456.986C47.067%2c-467.781%2c-36.223%2c-433.313%2c-117.481%2c-400.103C-191.504%2c-369.85%2c-257.293%2c-328.242%2c-315.359%2c-273.26C-378.794%2c-213.195%2c-449.458%2c-152.592%2c-468.84%2c-67.409C-488.778%2c20.214%2c-466.311%2c114.622%2c-421.316%2c192.409C-378.377%2c266.642%2c-297.452%2c304.253%2c-226.23%2c352.02C-153.476%2c400.815%2c-87.231%2c483.026%2c0%2c474.975' fill='%23e2e2e2'%3e%3c/path%3e%3cpath d='M1440 1068.288C1562.251 1075.4299999999998 1689.367 1173.95 1796.856 1115.279 1903.4270000000001 1057.109 1907.844 906.466 1947.009 791.543 1982.262 688.0989999999999 2038.587 583.975 2014.231 477.438 1990.4270000000001 373.31600000000003 1879.9270000000001 319.322 1818.996 231.598 1748.174 129.63299999999998 1742.156-31.119000000000028 1627.662-79.11699999999996 1514.514-126.54999999999995 1393.718-32.98299999999995 1276.837 4.317000000000007 1162.984 40.650999999999954 1038.442 54.72300000000001 951.46 136.678 860.264 222.603 796.163 341.132 786.753 466.077 777.587 587.787 843.963 698.2470000000001 901.043 806.133 955.134 908.369 1004.9580000000001 1024.502 1108.969 1075.094 1210.269 1124.367 1327.544 1061.718 1440 1068.288' fill='%23fafafa'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1079'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e")`}
				bgSize={"cover"}>
				<Flex
					alignItems={"center"}
					flexDir={"column"}
					gap={"70px"}
					w={"100%"}
					overflowY={"hidden"}
					maxW={"1700px"}>
					<HomeExplain />
					<Seperator />
					<Box>
						<Heading textAlign={"center"} mb={"70px"} as={"h2"}>
							Häufig gestellte Fragen:
						</Heading>
						<FAQSection faqType={"all"} />
					</Box>
					<Box mb={"70px"}>
						<Link to={"/products"}>
							<Button>Zu den Produkten</Button>
						</Link>
					</Box>
				</Flex>
			</Flex>
		</Page>
	);
}
